import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// Fontes
import "./assets/fonts/Poppins/poppins.css";
import "./assets/fonts/Metropolis/metropolis.css";

// Context
import AuthContextProvider from "./context/auth";

import Routes from "./routes/routes";
import Drawer from "./components/navigation/drawer";
import PremiumTrial from "./components/modal/premiumTrial";

function App() {
  const visible = useSelector((state) => state.drawer.visible);
  const { t } = useTranslation();

  document.title = t("nomeJogo1");

  return (
    <AuthContextProvider>
      <div className={`no-scroll`}>
        <div
          className={`main-content ${
            visible ? "drawer-open" : "drawer-closed"
          }`}
        >
          <Routes />
        </div>
        <Drawer />
        <PremiumTrial />
      </div>
    </AuthContextProvider>
  );
}

export default App;
